<template>
	<div id="app">
		<nav-heard />
		<div class="layout-body"><router-view /></div>
		<footers />
	</div>
</template>
<script>
import navHeard from "./components/Heard";
import footers from "./components/Footers";
export default {
	components: { navHeard, footers },
	watch: {
		$route() {
			document.documentElement.scrollTop = document.body.scrollTop = 0;
		},
	},
};
</script>
<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

#nav {
	padding: 30px;
}

#nav a {
	font-weight: bold;
	color: #2c3e50;
}

#nav a.router-link-exact-active {
	color: #42b983;
}
.layout-body {
	margin-top: 70px;
}
</style>
